import { useEffect, useRef, useState } from 'react';
import HttpClient from '../../utils/HttpClient';
import { useNavigate } from "react-router-dom";
import postbanneimmhg from "../../../src/Images/postbanneimmhg.png";
import prodlikeicon from "../../../src/Images/prodlikeicon.png";
import commenytstproodiuificon from "../../../src/Images/commenytstproodiuificon.png";
import msgiocn from "../../../src/Images/msgiocn.png";
import Neoologoasjji from "../../../src/Images/Neoologoasjji.png";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { commentAdd, ShareModalonOff } from '../../Redux/Slice/PostSlice';
import { formatDateAgo } from '../../utils/Helper';
import prodlikedicon from "../../../src/Images/liked.png";
import PostEnqueyModalNew from '../../Modal/PostEnqueyModalNew';
import ProfileShare from '../../Modal/ProfileShare';
import PostCommentsNew from "../SearchHome/PostCommentsNew";
import BusinessPostEditModal from "../../Modal/BusinessPostEditModal";
import PostSkeleton from './PostSkeleton';

const PostDetailsSubsection = ({ id }) => {
    const [data, setData] = useState({});
    const navigate = useNavigate()
    const [threedpotsspclmodal, setThreedpotsspclmodal] = useState(false);
    const divSectionRef = useRef(null);
    const dispatch = useDispatch()
    const [sharemodal, setSharemodal] = useState(false);
    const [postLink, setPostLink] = useState("")
    const [commentboxmodal, setCommentboxmodal] = useState(true);
    const { ShareModalOpenClose, UserProfileID } = useSelector((state) => state.app);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            getPostDetails(id);
        } else {
            navigate("/ownpostpage");
        }
    }, [id]);

    const getPostDetails = (id) => {
        const res = HttpClient.requestData(`post-details/${id}`, "GET", {}).then((res) => {
            if (res.data.length === 0) {
                navigate("/ownpostpage");
                return;
            }
            setData(res.data[0]);
            setLoading(false);
        }).catch((error) => {
            console.error("Error fetching details:", error);
            setLoading(false);
        });
    }

    const threedotssettingclcil = () => {
        setThreedpotsspclmodal(!threedpotsspclmodal)
    }

    const copyPostLink = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(postUrl).then(() => {
                toast.success("Copied Successfully");
                setThreedpotsspclmodal(false)
            });
        } else {
            toast.error("Clipboard not supported in this browser.")
        }
    }

    const shareClick = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        setPostLink(postUrl)
        setSharemodal(!sharemodal);
        dispatch(ShareModalonOff(true));
    };

    const handleClickOutside = (e) => {
        if (divSectionRef.current && !divSectionRef.current.contains(e.target)) {
            setThreedpotsspclmodal(false)
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const commentsboxoscopemnn = () => {
        setCommentboxmodal(!commentboxmodal);
    }

    const [commentText, setCommentText] = useState("")
    const handleCommentSend = (e, postId) => {
        e.preventDefault()
        const data = {
            postId: postId,
            comment: commentText
        }

        dispatch(commentAdd(data))
        getPostDetails(id);
        setCommentText("")
    }

    const handlePostLike = async (e, data) => {
        e.preventDefault()
        if (UserProfileID?._id === data?.userData?._id) return
        try {
            const response = await HttpClient.requestData(
                "business-post-like",
                "POST",
                { postId: data?._id }
            );
            if (response.status) {
                getPostDetails(id);
            } else {
                console.error("Error in Like/Dislike");
            }
        } catch (error) {
            console.error("Error submitting Like/Dislike:", error);
        } finally {
            getPostDetails(id);
        }
    }

    const [queryPostID, setQueryPostID] = useState()
    const [sendQueryModal, setSendQueryModal] = useState(false)
    const [selectedPostData, setSelectedPostData] = useState()

    const handleQuery = (e, id, userId, item) => {
        e.preventDefault()
        setQueryPostID(id)
        setSelectedPostData(item)
        UserProfileID?._id !== userId && setSendQueryModal(!sendQueryModal)
    }

    const handleOnPostUpdate = () => {
        getPostDetails(id);
    }

    const hidePost = async (e, postId) => {
        e.preventDefault()
        try {
            const response = await HttpClient.requestData(
                `hide-post/${postId}`,
                "PUT",
            );
            if (response.status) {
                toast.success("Post removed successfully.")
            } else {
                console.error("Error in removing post.");
            }
        } catch (error) {
            console.error("Error occured!", error);
        } finally {
            // dispatch(LoadBusinessPostsInBackground())
            navigate("/ownpostpage");
        }
    }

    const [showPostEditModal, setShowPostEditModal] = useState(false)
    const togglePostEditModal = () => {
        setShowPostEditModal(!showPostEditModal)
        getPostDetails(id);
    }

    return (
        <div>
            {loading ? <PostSkeleton /> :
                <>
                    <div className='post-detail-class'>
                        <div className='allpostowndmaimndivallelemntnesmain'>
                            <div className='allpostowndmaimndivallelemnt'>
                                <div className='allpostimagedesuigfnatinob'>
                                    <div className='allposttslodjjimg'>
                                        <img src={data?.userData?.businessProfilePic || Neoologoasjji} alt='...' />
                                    </div>
                                    <div className=''>
                                        <h4 className='neeporoalposttsheadr'>{data?.userData?.companyName}</h4>
                                        <p className='cmskshhstdiifgysyttxtpop'>{data?.userData?.companytypename}</p>
                                    </div>
                                </div>
                                <div className='crosasddoproidikdsjbhidivflx'>
                                    <div className='threediostyiicpnggsuc'>
                                        <div className='threediostyiicpn' onClick={threedotssettingclcil} style={{ cursor: "pointer" }}>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </div>
                                        {threedpotsspclmodal && <div className='threedotssettingdiv' ref={divSectionRef}>
                                            <ul className="userMenu">
                                                <li>
                                                    <a
                                                        href="javascript:"
                                                        onClick={(e) => copyPostLink(e, data?._id)}
                                                    >
                                                        <i className="fa-solid fa-link mr-2"></i>
                                                        Copy post link
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:"
                                                        onClick={(e) => shareClick(e, data?._id)}
                                                    >
                                                        <i className="fa-solid fa-share-nodes  mr-2"></i>
                                                        Share post link
                                                    </a>
                                                </li>
                                                {UserProfileID?._id === data?.userData?._id &&
                                                    <>
                                                        <li>
                                                            <a href="javascript:"
                                                                onClick={(e) => togglePostEditModal(e, data)}
                                                            >
                                                                <i className="fa-regular fa-edit mr-2"></i>
                                                                Edit post
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="javascript:"
                                                                onClick={(e) => hidePost(e, data?._id)}
                                                            >
                                                                <i className="fa-solid fa-trash mr-2"></i>
                                                                Delete
                                                            </a>
                                                        </li>
                                                    </>
                                                }

                                                {/* <li>
                                            <a href="/">
                                                <i className="fa-regular fa-bookmark mr-2"></i>
                                                Save post
                                            </a>
                                        </li>

                                        <li>
                                            <a href="/">
                                                <i className="fa-solid fa-eye-slash mr-2"></i>
                                                Not interested
                                            </a>
                                        </li> */}
                                            </ul>
                                        </div>}
                                    </div>
                                </div>
                            </div>

                            <div className='beaiuttisprofuductimh'>
                                <img src={data?.file || postbanneimmhg} alt={data?.subject} title={data?.subject} />
                            </div>
                        </div>

                        <div className=''>
                            <p className='producttdescttxpppyip' style={{ font: "500 17px / 20px Roboto", marginBottom: "3px" }}>{data?.subject || "..."}</p>
                        </div>
                        <div className=''>
                            <p className="abttsbttetxtttpp" style={{ whiteSpace: 'pre-wrap', overflowWrap: "break-word" }}>{data?.description || ""}</p>
                        </div>

                        <div className=''>
                            <p className='timttksopooiisuttxpp'>
                                {formatDateAgo(data?.createdOn)}
                            </p>
                        </div>
                    </div>

                    <div>
                        <div className='producudtlikecomrnttsennsuiquerydiv'>
                            <div className='prodctlikecmntenquerydiv'>
                                <div className="produucvtsdlikeinmncomnfdivvhjjd"
                                    onClick={(e) => { handlePostLike(e, data) }}
                                >
                                    <div className="produucvtsdlikeinmncomnf">
                                        <img
                                            src={data?.PostLikeData?.some(item => item.likedBy === UserProfileID?._id) ? prodlikedicon : prodlikeicon}
                                            alt=""
                                        />
                                    </div>
                                    <p className="likkskjsbtcomnbvtyoipuxtt">
                                        Like <span>{data?.PostLikeCount}</span>
                                    </p>
                                </div>

                                <div className='produucvtsdlikeinmncomnfdivvhjjd' onClick={commentsboxoscopemnn}>
                                    <div className='produucvtsdlikeinmncomnf'>
                                        <img src={commenytstproodiuificon} alt='' />

                                    </div>
                                    <p className='likkskjsbtcomnbvtyoipuxtt'>Comment  <span>{data?.PostCommentData?.length}</span></p>
                                </div>

                                <div className="produucvtsdlikeinmncomnfdivvhjjd"
                                    onClick={(e) => handleQuery(e, data?._id, data?.userData?._id, data)}
                                >
                                    <div className="produucvtsdlikeinmncomnf">
                                        <img
                                            src={msgiocn}
                                            alt=""
                                        />
                                    </div>
                                    <p className="likkskjsbtcomnbvtyoipuxtt">Send Equiry</p>
                                </div>
                            </div>
                        </div>

                        {/* {commentboxmodal &&
                    <div className='producytppostcommnentdiv'
                    // style={{ display: "none" }}
                    >
                        <div className='commuisonnporttsidivrrls'>
                            <div className='textareadibmainmainbrdrnewalada'>
                                <div className='textareadibmain'>
                                    <textarea rows={4} cols={4} className='textareadibmainrerarenewalada' placeholder='Write a Comment'
                                        onChange={(e) => setCommentText(e.target.value)}
                                        value={commentText || ""}
                                    />
                                </div>
                                <div className="mesagsendidvmain"
                                    onClick={(e) => handleCommentSend(e, data?._id)}
                                >
                                    <button className='posyynbmrmodiuvsujusvbntn'>Post</button>
                                </div>
                            </div>

                        </div>
                    </div>

                } */}

                        <div className='commenytstthowitxtpehht'>
                            {/* {
                        data?.PostCommentData?.map((comment, index) => {
                            return (
                                <>
                                    <div className='commentshpwfrsttcmontdiv' key={`comment-${index}`}>
                                        <div className='profikellcmnjhhrrddivflxttst'>
                                            <div className='profikellcmntimgdivflxttst'>
                                                <div className='commentproofilleimg'>
                                                    <img src={comment?.commentedBy[0]?.profilePhoto || cmtprofileoneimg} alt='...' />
                                                </div>
                                                <p className='commporosttxttnamepp'>{comment?.commentedBy[0]?.personName}</p>
                                            </div>

                                            <p className='commporosttxttnamepp'>{formatDateAgo(comment?.createdOn)}</p>
                                        </div>
                                        <p className='commsoprpodttctxppp'>
                                            {comment?.comment}
                                        </p>
                                    </div>
                                </>
                            )
                        })
                    } */}
                            <PostCommentsNew data={data?.PostCommentData} postProfileId={data?.profileId} postId={data?._id} onPostUpdate={handleOnPostUpdate} />
                        </div>

                    </div>

                    {sendQueryModal &&
                        <><PostEnqueyModalNew closemodal={setSendQueryModal} post={queryPostID} postData={selectedPostData} /></>
                    }

                    {ShareModalOpenClose && (
                        <ProfileShare
                            whatsApp={postLink}
                            linkedInLink={postLink}
                            facebookLink={postLink}
                            userLink={postLink}
                            instaLink={postLink}
                            emailId={postLink}
                        />
                    )}

                    {showPostEditModal && <BusinessPostEditModal closemodal={togglePostEditModal} data={data} />}
                </>
            }
        </div>
    );
};
export default PostDetailsSubsection;